import { MutationTree } from "vuex";
import { InstructorState } from "./types";

export const mutations: MutationTree<InstructorState> = {};
